import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() {
  }

  setLanguage(lang: string) {
    sessionStorage.setItem('lang', lang);
  }

  getLanguage() {
    return sessionStorage.getItem('lang');
  }

  getStartDate() {
    return sessionStorage.getItem('startDate');
  }

  setStartDate(startDate: string) {
    sessionStorage.setItem('startDate', startDate);
  }

  getEndDate() {
    return sessionStorage.getItem('endDate');
  }

  setEndDate(endDate: string) {
    sessionStorage.setItem('endDate', endDate);
  }

  getMember() {
    return sessionStorage.getItem('member');
  }

  setMember(member: string) {
    sessionStorage.setItem('member', member);
  }

  getSelectedAllowancesView() {
    return sessionStorage.getItem('allowancesView');
  }

  setSelectedAllowancesView(view: string) {
    sessionStorage.setItem('allowancesView', view);
  }

  setSelectedYearAllowances(selectedYear: string) {
    sessionStorage.setItem('selectedYearAllowances', selectedYear);
  }

  getSelectedYearAllowances() {
    return sessionStorage.getItem('selectedYearAllowances');
  }

  removeSelectedYearAllowances() {
    sessionStorage.removeItem('selectedYearAllowances');
  }

  getSelectedElectronicDocumentType() {
    return sessionStorage.getItem('electronicDocumentType');
  }

  setSelectedElectronicDocumentType(type: string) {
    sessionStorage.setItem('electronicDocumentType', type);
  }

  getSelectedYearElectronicDocuments() {
    return sessionStorage.getItem('selectedYearElectronicDocuments');
  }

  removeSelectedYearElectronicDocuments() {
    sessionStorage.removeItem('selectedYearElectronicDocuments');
  }

  setSelectedYearElectronicDocuments(selectedYear: string) {
    sessionStorage.setItem('selectedYearElectronicDocuments', selectedYear);
  }

  setUnreadMessagesPopUp(niss: string, hasShown: string) {
    sessionStorage.setItem(`hasShownUnreadPopup_${niss}`, hasShown);
  }

  getUnreadMessagesPopUp(niss: string) {
    return sessionStorage.getItem(`hasShownUnreadPopup_${niss}`);
  }

  removeUnreadMessagesPopUp(niss: string) {
    sessionStorage.removeItem(`hasShownUnreadPopup_${niss}`);
  }

  /**
   * Generic localStorage getter for persistent preferences
   */
  get(key: string): string | null {
    return localStorage.getItem(key);
  }

  /**
   * Generic localStorage setter for persistent preferences
   */
  set(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  /**
   * Generic localStorage remover
   */
  remove(key: string): void {
    localStorage.removeItem(key);
  }
}
